import type { AjaxResponse } from 'rxjs/ajax';

import { sgwtConnect } from '../../../api/connect';

export default function <T>(response: AjaxResponse<T>): AjaxResponse<T> {
  if (response.status === 401) {
    if (!sgwtConnect.isAuthorized()) {
      sgwtConnect.requestAuthorization();
    }
  }

  return response;
}
